import React from "react";
import { Card, CardHeader, Row, Col, CardBody } from "shards-react";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { TiEdit, TiEyeOutline, TiDeleteOutline, TiTick, TiTimes } from "react-icons/ti";
import UserDataService from "../../services/user.service";
import { FcPlus } from "react-icons/fc";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { actions as AppActions } from "../../_stores/app.store";
import CustomPagination from "../common/CustomPagination";
import authStore from "../../_stores/auth.store";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import moment from "moment";

const perPage = 10;

class ViewUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      userList_paged: [],
    };
    this.aggridRef = React.createRef();
  }

  componentDidMount() {
    this.retrieveUsers();
  }

  componentDidUpdate(prevProps) {}

  retrieveUsers() {
    AppActions.setLoading(true);
    UserDataService.getAll().then((response) => {
      AppActions.setLoading(false);
      this.setState({
        userList:
          authStore.getState().auth_reducer.user.role === "admin"
            ? response.data.data.filter((dt) => dt.role === "user")
            : response.data.data,
      });
    });
  }

  deleteUser(id) {
    AppActions.setLoading(true);
    UserDataService.delete(id).then((response) => {
      this.retrieveUsers();
      this.props.notify("success", "User Deleted");
    })
    .catch((error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      this.setState({
        message: message,
      });
      this.props.notify("error", message);
      AppActions.setLoading(false);
    });
  }

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };


  render() {
    const { userList } = this.state;
    const columnDefs = [
      {headerName: "User Name", field: "name", filter: true, sortable:true, unSortIcon:true },
      {headerName: "Email", field: "email",filter: true, sortable:true, unSortIcon:true},
      {headerName: "Role", field: "role",filter: true, sortable:true, unSortIcon:true},
      {headerName: "SSO User", field: "ssoUser",filter: true, sortable:true, unSortIcon:true, width:"150",
        cellRendererFramework: (data) => {
          return (data.value ? <span className="text-primary"><TiTick size={18} /></span> :  <span className="text-warning"><TiTimes size={18} /></span>)
        } 
      },
      {headerName: "Active", field: "active",filter: true, sortable:true, unSortIcon:true, width:"150",
        cellRendererFramework: (data) => {
          return (data.value ? <span className="text-primary"><TiTick size={18} /></span> :  <span className="text-warning"><TiTimes size={18} /></span>)
        } 
      },
      {headerName: "updatedAt", field: "updatedAt",filter: true,  sortable:true, width:"160",
          cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "action", field:"id", 
          cellRendererFramework: (data) => {
              return <>
                    <Link title="Details" className="text-primary mr-2" to={"/user-details/"+data.value}><TiEyeOutline  size="20" /></Link>
                    <Link title="Edit" className="text-success mr-2" to={"/edit-user/"+data.value}><TiEdit  size="20" /></Link>
                    {authStore.getState().auth_reducer.user.role === "superadmin" && (
                      <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteUser(data.value)}><TiDeleteOutline size="20" /></span>
                    )}
                  </>
         }
      }
    ]

    return (
      <>
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">
                  Users List
                  <Link className="btn btn-primary ml-4" to={"/create-user"}>
                    <FcPlus /> Create New User
                  </Link>
                </h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
              <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                  <div className="example-header">
                    Page Size: &nbsp;
                    <select onChange={this.onPageSizeChanged} id="page-size">
                      <option value="10" selected={true}>
                        10
                      </option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                  <AgGridReact
                      ref={this.aggridRef}
                      pagination={true}
                      rowHeight={50}
                      paginationPageSize={perPage}
                      columnDefs={columnDefs}
                      rowData={userList}
                  >
                  </AgGridReact>
                </div>
      
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default ViewUsers;
